import { Options, render } from "ejs";

import { TemplateFile, TemplateFileOptions } from "./TemplateFile";

export interface EjsTemplateFile extends TemplateFile {
  content: string;
  ejsData?: Record<string, any>;
  ejsOptions?: Omit<Options, "_with" | "strict" | "destructuredLocals">;
}

export type EjsTemplateFileOptions = TemplateFileOptions &
  EjsTemplateFile["ejsOptions"];

export function ejsTemplateFile(
  content: string,
  ejsData?: EjsTemplateFile["ejsData"],
  { base64, binary, executable, ...ejsOptions }: EjsTemplateFileOptions = {},
): EjsTemplateFile {
  return {
    content,
    ejsData,
    base64,
    binary,
    executable,
    ejsOptions,
    getContent: ejsTemplateFileContent,
  } as EjsTemplateFile;
}

function ejsTemplateFileContent(
  this: EjsTemplateFile,
): string | Promise<string> {
  return render(this.content, this.ejsData, {
    strict: true,
    destructuredLocals: Object.keys(this.ejsData ?? {}),
    ...this.ejsOptions,
  });
}
